type TestimonialType = {
  img: string;
  name: string;
  tr_title: string;
  tr_text: string;
  tr_days_ago: string;
  verifiedBuyer: string;
}[];

export const testimonialsSmallData: TestimonialType = [
  {
    img: `${window.template_root}/v1/testimonialsSmall/1.png`,
    name: "Barbara K.",
    tr_title: "Amazing remedy for mom life",
    tr_text:
      "Since becoming a new mom, sleepless nights were my norm. The constant fatigue was affecting my ability to enjoy motherhood. After getting Ashwagandha, i started falling asleep more easily and staying asleep longer. Now even if the baby wakes me, i can drift back to sleep without tossing and turning!",
    tr_days_ago: "14 days ago",
    verifiedBuyer: "Verified buyer",
  },
  {
    img: `${window.template_root}/v1/testimonialsSmall/2.png`,
    name: "Amanda A.",
    tr_title: "Really helps with my stress",
    tr_text:
      "College brought on more stress than I anticipated. Between exams and part-time work, my anxiety was at an all-time high. BioVitals Ashwagandha has been a lifesaver. After a month of use, I feel calmer and more focused. My concentration during lectures has improved, and I approach tests with confidence rather than dread.",
    tr_days_ago: "14 days ago",
    verifiedBuyer: "Verified buyer",
  },
  {
    img: `${window.template_root}/v1/testimonialsSmall/3.png`,
    name: "Miguel J.",
    tr_title: "No more brain fog!",
    tr_text:
      "Entering my 50s i began struggling with memory lapses and a constant brain fog that hindered my performance at work. It was both frustrating and concerning. But this supplement improved my mental clarity and i can tackle complex projects with ease again. It's like my cognitive function got a much needed boost!",
    tr_days_ago: "14 days ago",
    verifiedBuyer: "Verified buyer",
  },
];
